/**
 * Declarative Status Evaluation Rules (Table-Driven Design).
 * Evaluates ONLY critical alert states: Emergency, Forced/Intrusion, and Long Open Door.
 * All other operational states (Open, Closed, Idle, Normal, etc.) resolve to NORMAL.
 */
const ALERT_RULES = [
  {
    key: 'EMERGENCY',
    match: (statuses) => statuses.some((s) => s.includes('EMERGENCY') || s.includes('EVACUAT')),
    result: { label: 'Emergencia', dotClass: 'dot-red', isOffline: false, unifiedKey: 'EMERGENCY' },
  },
  {
    key: 'FORCED',
    match: (statuses) => statuses.some((s) => s.includes('FORCED') || s.includes('INTRUS')),
    result: { label: 'Puerta Forzada', dotClass: 'dot-red', isOffline: false, unifiedKey: 'FORCED' },
  },
  {
    key: 'HELD_OPEN',
    match: (statuses) => statuses.some((s) => s.includes('HELD') || s.includes('LONG_OPEN')),
    result: { label: 'Puerta Retenida', dotClass: 'dot-yellow', isOffline: false, unifiedKey: 'HELD_OPEN' },
  },
];

const DEFAULT_NORMAL_STATUS = { label: 'En línea', dotClass: 'dot-green', isOffline: false, unifiedKey: 'NORMAL' };

/**
 * Resolves unified door alert status.
 * Returns an alert status object ONLY if the door is in Emergency, Forced, or Long Open Door state.
 * Returns NORMAL (no alert ring) for all other states.
 *
 * @param {object} door - Door state object
 * @returns {object} { label, dotClass, isOffline, unifiedKey }
 */
export const getUnifiedDoorStatus = (door) => {
  if (!door) {
    return DEFAULT_NORMAL_STATUS;
  }

  const rawStatuses = [door.masterStatus, door.slaveStatus, door.status, door.state, door.eventType];
  const activeStatuses = rawStatuses.filter((s) => typeof s === 'string').map((s) => s.toUpperCase());

  const matchedAlert = ALERT_RULES.find((rule) => rule.match(activeStatuses));

  return matchedAlert ? matchedAlert.result : DEFAULT_NORMAL_STATUS;
};

export default getUnifiedDoorStatus;
